// 永平寺環境とデフォルト環境の切替

// 環境設定の取得
function getBaseEnvironment() {
  const envVar = import.meta.env.VITE_BASE_ENVIRONMENT;

  if (envVar === "eiheiji") {
    return "eiheiji";
  }
  return "default";
}

// 永平寺環境かどうかを判定
export function isEiheijiEnvironment(): boolean {
  return getBaseEnvironment() === "eiheiji";
}
